export default __webpack_public_path__ + "static/banner-wedding-clever-ways-to-cut-your-wedding-costs-f8a6051689fc656a91f941c09bc74437.jpg";